import type { FetchOptions } from 'ofetch'
import type { AnyApiSpec } from '@st/openapi-tools'
import { hash } from '@st/utils'
import type { TypedUseFetch } from '../nuxtOpenapiTypeHelpers'

export function useCreateFetch<ApiSchema extends AnyApiSpec>(
  useApiConfig: () => {
    createApiConfig: (options?: FetchOptions) => FetchOptions
  },
): TypedUseFetch<ApiSchema> {
  return (url, options) => {
    const { createApiConfig } = useApiConfig()
    const config = createApiConfig(options as any)

    // Генерируем уникальный ключ для кэширования
    const key =
      options?.key ??
      hash({
        url,
        method: toValue(config.method),
        body: toValue(config.body),
      })

    return useFetch(url, {
      key,
      ...(config as any),
    })
  }
}
